import { Injectable } from '@angular/core';
import { AlertController, Alert, AlertOptions } from 'ionic-angular';

@Injectable()
export class AlertProvider {
  alert: Alert;

  constructor(public alertCtrl: AlertController) {}

  public createAlert(options: AlertOptions): Alert {
    return this.alertCtrl.create(options);
  }

  public presentAlert(options?: AlertOptions): Promise<any> {
    this.alert = this.alertCtrl.create(options);
    return this.alert.present();
  }

  public dismissAlert(): Promise<any> {
    try {
      return this.alert.dismiss();
    } catch(error) {}
  }
}
